export const OPEN_CONTACT = 'OPEN_CONTACT';
export const CLOSE_CONTACT = 'CLOSE_CONTACT';


// WEBPACK FOOTER //
// ./src/store/modules/modal/modal.types.js